import React from 'react';
import { Flex, Heading, Text } from 'rebass';
import moment from 'moment'
import styled from 'styled-components';

import ItemCollection from '../../components/icons/ItemCollection';

const Icon = styled(Flex)`
  display: none;
  @media screen and (min-width: 52em) {
    display: block;
  }
`;
export const LabStep3 = ({currentStep}) => {
  return (
    <Flex flexDirection={['column', 'row']} flex={1}>
      <Icon
        mr={[0, 4]}
        mb={[3, 0]}
        alignItems="flex-start"
        justifyContent="center"
      >
        <ItemCollection width={90} />
      </Icon>

      <Flex flexDirection="column" flex={1}>
        <Heading mb={4}>
            Your kit has arrived at our lab
        </Heading>
        <Text lineHeight={1.6}>
          USPS indicates that your sample was delivered {moment(currentStep.delivered, 'YYYY-MM-DD').format('MMMM Do, YYYY')}. You can expect your results around {moment(currentStep.eta, 'YYYY-MM-DD').format('MMMM Do, YYYY')}. Just a few more days...
        </Text>
      </Flex>
    </Flex>
  );
};
